export function isServiceWorkerSupported(): boolean {
  return "serviceWorker" in navigator;
}

export function isBackgroundSyncAvailable(): boolean {
  return "sync" in window.ServiceWorkerRegistration.prototype;
}

export function isPushNotificationSupported(): boolean {
  return "Notification" in window;
}

export function isLocalhost() {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );
}

export function getActiveServiceWorker() {
  return navigator.serviceWorker.controller;
}
